import { render, staticRenderFns } from "./PlatformSpinner.vue?vue&type=template&id=91e2f94c"
import script from "./PlatformSpinner.vue?vue&type=script&lang=ts"
export * from "./PlatformSpinner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports